import TextField from "../../../../components/fields/textField/TextField.vue";
import ConfirmPasswordDialog from "../../../../components/dialog/confirmPassword/ConfirmPasswordDialog.vue";
import ParametrizarService from "../../../../services/ParametrizarService";
import FormDialog from "../../../../components/dialog/form/FormDialog.vue";
import { AssinaturaMixin } from "@/mixins/assinaturaMixin";
import { SnackbarMixin } from "@/mixins/snackbarMixin";
import {SnackBarModule} from "@/modules/SnackBarModule";



export default {
    name: "DialogParametrizar",
    components: {
        TextField,
        ConfirmPasswordDialog,
        FormDialog,
        SnackBarModule
    },
    mixins:[AssinaturaMixin,SnackbarMixin ],
    props: {
        activeDialog: {
            type: Boolean,
            default: false,
        }
    },
    data: () => ({
        headers: [
            { text: "Cargo", value: "nome", sortable: false },
            { text: "", value: "atribuir", sortable: false, width: "100" },
        ],
        data: [],
        errors: [],
        disabled: {
            nome: false,
            cargos: false,
        },
        form: {
            hora_minuto:false
        },
        formValid: true,
        loading: {
            table: false,
        },
        btn:{
            loader:null,
            loading: false,
        },
        page: 1,
        pageCount: 0,
        itemsPerPage: 10,
        search: "",
        showFormDialog: false,
        activeBtnDialog:false,
        showDialogConfirmPassword: false,
        formConfirmPassword: {
            justificativa:"",
            password:""
        },
        send: {
            function: () => {},
            params: null,
        },

        cargos: [],
    }),

    watch: {
        activeDialog() {
            console.log(this.usuarioid)
                this.showFormDialog = !this.showFormDialog;
        },
        loader () {
            const l = this.loader
            this[l] = !this[l]

            setTimeout(() => (this[l] = false), 3000)

            this.loader = null
        },
    },

    created() {
        this.getEditData();
        this.initializeFormConfirmPassword();

    },

    methods: {
        goTo(path) {
            this.$router.push(path);
        },
        async saveHoraParam() {
            console.log(this.form.hora_minuto.length)
            if(this.form.hora_minuto === undefined || this.form.hora_minuto === '00:00' || this.form.hora_minuto.length <=1) {
                this.btn.loader = null;
                this.btn.loading = false;
                    ///SnackBarModule('Você precisa informa uma hora e minuto acima para poder salvar esse campo','error');
                    SnackBarModule('Você precisa informar uma hora e minuto para poder salvar esse campo','error');
                return;

            }
            this.btn.loader = 'loading';
            this.btn.loading = true;
            const saved = ParametrizarService.cadastrarHora(this.form);
            saved.then((res) => {
                if(res.error === false) {
                    SnackBarModule('Hora/minuto atualizado com sucesso!','success');
                    this.showFormDialog = !this.showFormDialog;
                    this.btn.loader = null;
                    this.btn.loading = false;
                }
            })
        },
        async atualizarAgoraParam() {
            const saved = ParametrizarService.getRodarAgora();
            SnackBarModule('Operação realizada com sucesso!','success');
            saved.then((res) => {
                    if(res.error === false) {
                        console.log(res);
                    }
            });
        },


        async getEditData() {
            const response = ParametrizarService.getHora();
            response.then((res) => {
                this.form.hora_minuto = res.content.res;
            })
        },

        async getCargos() {
            this.loading.table = true;

            const response = await ParametrizarService.getCargos();
            this.cargos = await response;
            this.loading.table = false;
        },



        initializeForm() {
            this.form = {
                id_cargo: [],
                arrayCargos: [],
            };
        },



        async save() {
            this.errors = [];



            let arrayRemovidos = [];
            let arrayAdicionados = [];

            arrayRemovidos = this.form.arrayCargos.filter(
                (cargo) =>
                    !this.form.id_cargo.includes(cargo),
            );

            arrayAdicionados = this.form.id_cargo.filter(
                (cargo) =>
                    !this.form.arrayCargos.includes(cargo),
            );

            let response = {};
            if (arrayRemovidos.length > 0) {
                response = await ParametrizarService.removerCargoPerfil(
                    this.perfilid,
                    { id_cargo: arrayRemovidos },
                );
            }

            if (!response.error && arrayAdicionados.length > 0) {
                response = await ParametrizarService.atribuirCargoPerfil(
                    this.perfilid,
                    { id_cargo: arrayAdicionados },
                );
            }

            if (!response.error) {
                SnackBarModule("As Cargos do perfil foram atualizadas com sucesso","success");
                this.showFormDialog = !this.showFormDialog;
            } else {
                const message = await response.response;
                SnackBarModule(message, "error");
                this.errors.push(message);
            }
        },
    },
};
